import { render, staticRenderFns } from "./CreateClientModal.vue?vue&type=template&id=bb409eec"
import script from "./CreateClientModal.vue?vue&type=script&lang=js"
export * from "./CreateClientModal.vue?vue&type=script&lang=js"
import style0 from "./CreateClientModal.vue?vue&type=style&index=0&id=bb409eec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports